<template>
<div
    v-if="profile != null"
>
    <m-make-payment-app-bar
        :value="organization_label"
        :banner_branding="banner_branding"
    />

<div
    style="padding-left: 30px; padding-right: 30px;"
>
    <div
        v-if="form.is_archived"
        style="text-align: center; margin-top: 100px;"
    >
        This form is no longer available.
    </div>
    <div
        v-else
    >

        <div
            style="text-align: center; margin-top: 30px;"
            v-if="show_thank_you"
        >
            <div
                style="font-size: 32px; margin-bottom: 30px;"
            >   
                {{form.after_submit_title}}
            </div>

            <div
            >
                <m-showdown
                    :value="form.md_after_submit_instructions"
                />
            </div>
        </div>
        

        <div
            v-else
        >
            <h2
                style="margin-top: 30px; margin-bottom: 30px"
                v-if="form.title != null && form.title.length > 0"
            >
                {{form.title}}
            </h2>

            <p
                style="margin-bottom: 30px"
            >
                <m-showdown
                    :value="form.md_instructions"
                />
            </p>

            <v-text-field
                label="First name"
                v-model="first_name"
                v-if="!has_payment"
            />

            <v-text-field
                label="Last name"
                v-model="last_name"
                v-if="!has_payment"
            />

            <v-text-field
                label="Phone Number"
                v-model="phone_number"
                type="tel"
                v-on:input="onChangeMobile"
                v-if="!has_payment"
            />

            
            <m-custom-form-field
                v-for="(item, index) in fields"
                :key="'custom_form_field_'+index"
                :field="item"
                :profile="profile"
                v-on:input="onChangeCustomField(item,$event)"
                v-on:input-payment="onChangePayment"
            />

            <div
                v-if="robust_age_gate"
            >
                <p>You must be 21 or older to receive our text messages.  Please enter your birthday in MM/DD/YYYY format so we can verify your age</p>

                <v-text-field
                    label="Birthday"
                    v-model="birthday"
                    hint="MM/DD/YYYY -- use a leading zero (e.g. 01 for January). slashes will be added automatically"
                    persistent-hint
                    v-on:input="onInputBirthday"
                    type="tel"
                />
            </div>

            <m-legal-checkbox-agreement
                :organization_id="organization_id"
                type="default-opt-in-form-agreement"
                v-model="agreement_cb"
                ref="agreement"
                style="margin-bottom: 15px"
                v-if="!has_payment"
                :override_patterns="profile.effective_consent_agreement_patterns"
            />

            <v-alert
                v-model="show_alert"
                color="primary"
                type="error"
                dismissible
                style="margin-top: 15px"
            >
                {{alert_text}}
            </v-alert>

            
            <div
                style="text-align: right; padding-top: 15px; margin-bottom: 30px;"
            >
                <v-btn
                    color="secondary"
                    v-on:click="onClickSubmit"
                >
                    Submit
                </v-btn>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
export default {
    data() {
        return {
            banner_branding: null,
            organization_account: null,
            form: null,
            fields: null,
            agreement_cb: false,

            first_name: null,
            last_name: null,
            phone_number: null,
            birthday: null,

            custom_field_values: {},

            show_alert: false,
            alert_text: null,

            show_thank_you: false,

            profile: null,

            payment_info: null,
        }
    },

    props: {
        in_test_mode: {
            type: Boolean,
            default: function() { return false; }
        },

        preview: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    mounted () {
        this.update();
    },

    methods: {
        update() 
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/forms/profile/:form_id',
            
                'params' : {
                        'form_id': this.$route.params.form_id, 
                    },
            
                'on_success': (data) => {
                        this.form = data.form;
                        this.fields = data.fields;
                        this.banner_branding = data.banner_branding;
                        this.organization_account = data.organization_account;
                        this.profile = data;
                    },
            
                'on_error': 'Unable to load form',
            });    
        },

        toggleShowAfterSubmit()
        {
            this.show_thank_you = !this.show_thank_you;
        },

        isBlank(value)
        {
            if ( value == null ) return true;
            if ( value.trim().length == 0 ) return true;
            return false;
        },

        onInputBirthday()
        {
            this.birthday = this.$rc.maskMMDDYYYY(this.birthday);
        },

        onChangeMobile(event)
        {
            this.phone_number = this.$rc.maskPhoneNumber(this.phone_number);
        },

        onChangeCustomField(item, new_value)
        {
            this.custom_field_values[item.form_field_id] = new_value;
        },

        onChangePayment(value)
        {
            this.payment_info = value;
        },

        onClickSubmit()
        {
            // Validate
            {
                if ( !this.has_payment && this.agreement_cb == false )
                {
                    this.show_alert = true;
                    this.alert_text = 'You must check the box granting us permission to text you.';
                    return;
                }

                if ( !this.has_payment && this.isBlank(this.first_name) ) 
                {
                    this.show_alert = true;
                    this.alert_text = 'A first name is required';
                    return false;
                }

                if ( !this.has_payment && this.isBlank(this.last_name) ) 
                {
                    this.show_alert = true;
                    this.alert_text = 'A last name is required';
                    return false;
                }

                if ( !this.has_payment && this.isBlank(this.phone_number) ) 
                {
                    this.show_alert = true;
                    this.alert_text = 'A phone number required';
                    return false;
                }

                if ( this.robust_age_gate && this.isBlank(this.birthday) )
                {
                    this.show_alert = true;
                    this.alert_text = 'A birth date is required';
                    return false;
                }

                if ( this.payment_info != null && this.payment_info.error != null )
                {
                    this.show_alert = true;
                    this.alert_text = this.payment_info.error;
                    return;
                }
            }

            this.show_alert = false;

            let post_data = {
                'form_id': this.$route.params.form_id, 
                
                'first_name': this.first_name,
                'last_name': this.last_name,
                'phone_number': this.phone_number,
                'birthday': this.birthday,

                'agreement_specimen': this.agreement_cb == true ? this.$refs['agreement'].getSpecimen() : null,

                'in_test_mode': this.in_test_mode,
                'payment_info': this.payment_info,

                ... this.custom_field_values,
            };

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/forms/submit',
            
                'params' : post_data,
            
                'on_success': (data) => {
                        if ( data.valid == false )
                        {
                            this.alert_text = data.message;
                            this.show_alert = true;
                            return;
                        }

                        if ( this.form.after_submit_redirect_to_custom_url && !this.in_test_mode )
                        {
                            document.location = this.form.after_submit_redirect_url;
                            return;
                        }

                        this.show_thank_you = true;
                    },
            
                'on_error': 'Unable to submit form',
            });
        },
    },

    computed: {
        robust_age_gate() {
            if ( this.has_payment ) 
                return false;

            if ( this.organization_account == null ) 
                return false;
            
            return this.organization_account.industry == 'wine';
        },

        organization_label()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.label;
        },

        organization_id()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.organization_id;
        },

        has_payment()
        {
            if ( this.fields == null ) return false;

            for ( let i = 0; i < this.fields.length; i++ )
            {
                if ( this.fields[i].type == 'payment' )
                    return true;
            }

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>